import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

const GUIDE_HERO = "https://static.prod-images.emergentagent.com/jobs/7e6ca0f8-68b2-4411-b9b5-f4664e141e03/images/c5e15c165982a14d36420e32a936a4cbda16b3bb8b3fbc098e58d763e7eb5972.png";

export default function GuidesPage() {
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/guides").then((r) => setGuides(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Seo
        title="Guides diabète & nutrition"
        description="Guides complets pour comprendre le diabète, l'index glycémique, l'alimentation adaptée et la vie quotidienne avec la maladie."
        keywords={["guide diabète", "comprendre diabète", "alimentation diabète", "IG bas guide"]}
        path="/guides"
      />
      <section className="container-x pt-20 pb-12" data-testid="guides-hero">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <p className="overline mb-3">Pour mieux vivre avec le diabète</p>
            <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight">Guides éditoriaux</h1>
            <p className="mt-6 text-lg text-[hsl(var(--text-secondary))] max-w-2xl">
              Comprendre la maladie, lire les étiquettes, gérer l'hypoglycémie, choisir ses féculents…
              Une bibliothèque claire et sans jargon, écrite par des passionnés et relue par des experts.
            </p>
          </div>
          <div className="md:col-span-5">
            <img src={GUIDE_HERO} alt="" className="w-full aspect-[5/4] object-cover rounded-sm" />
          </div>
        </div>
      </section>

      <section className="container-x py-12 pb-24">
        {loading ? (
          <div className="text-[hsl(var(--text-muted))]">Chargement…</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
            {guides.map((g) => (
              <Link
                key={g.id}
                to={`/guides/${g.slug}`}
                className="block border-b border-[hsl(var(--border-default))] pb-8 group"
                data-testid={`guide-list-item-${g.slug}`}
              >
                <p className="overline mb-3">{g.category} · {g.reading_time_min} min</p>
                <h2 className="font-serif text-3xl md:text-4xl leading-tight group-hover:text-[hsl(var(--brand-primary))] transition-colors">
                  {g.title}
                </h2>
                {g.subtitle && <p className="mt-2 font-serif italic text-lg text-[hsl(var(--text-secondary))]">{g.subtitle}</p>}
                <p className="mt-4 text-[hsl(var(--text-secondary))] line-clamp-3">{g.excerpt}</p>
                <p className="mt-4 text-xs uppercase tracking-wider text-[hsl(var(--brand-primary))]">Lire le guide →</p>
              </Link>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
